import { List } from '../objects/list';
import { LocaleActionTypes, SET_CURRENT_LOCALE, SET_LIST, SET_MAIN_LOCALE, SET_TRANSLATE_LOCALE, SET_LIST_LOCALE } from './actionTypes';
import { Locale } from '../objects/locale';

export const setCurrentLocale = (id: number): LocaleActionTypes => ({
    type: SET_CURRENT_LOCALE,
    payload: id
});

export const setList = (list: Locale[]): LocaleActionTypes => ({
    type: SET_LIST,
    payload: list
});

export const setListLocales = (list: List): LocaleActionTypes => ({
    type: SET_LIST_LOCALE,
    payload: list
});

export const setMainLocale = (id: number): LocaleActionTypes => ({
    type: SET_MAIN_LOCALE,
    payload: id
});

export const setTranslateLocale = (ids: number[]): LocaleActionTypes => ({
    type: SET_TRANSLATE_LOCALE,
    payload: ids
});